import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { Link } from 'react-router'
import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { tasks } from 'selectors/entities'
import Section from 'components/Section'
import { dependencies } from 'selectors/tasks'
import TaskCard from './TaskCard'

let select = dirtyRead(
	(state, props) => ({
		task: doc(state, props.objectID)
	  , tasks: dependencies(state, props)
	})
)

export class Depends extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="task/depends"
				title="Dependencies"
				badge={props.task.dependencies.length}
			>
				<List
					style={{
						backgroundColor: "transparent"
						, paddingTop: "0"
					}}
				>
					{(props.tasks)?
						R.map((task) =>
						task._id!=props.objectID && <TaskCard task={task} objectID={props.objectID} />
						, props.tasks)
						:""
					}
				</List>
            </Section>
		)
	}
}

export default connect(select, dataActions)(Depends)



// WEBPACK FOOTER //
// ./src/routes/manager/taskForm/Depends.js